"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const cheminfo_font_1 = require("cheminfo-font");
const Peaks_1 = __importDefault(require("cheminfo-font/lib-react-cjs/lib-react-tsx/nmr/Peaks"));
const react_2 = require("react");
const fa_1 = require("react-icons/fa");
const isInRange_1 = __importDefault(require("../../../data/utilities/isInRange"));
const ChartContext_1 = require("../../context/ChartContext");
const DispatchContext_1 = require("../../context/DispatchContext");
const PreferencesContext_1 = require("../../context/PreferencesContext");
const ActiveButton_1 = __importDefault(require("../../elements/ActiveButton"));
const Button_1 = __importDefault(require("../../elements/Button"));
const Alert_1 = require("../../elements/popup/Alert");
const Modal_1 = require("../../elements/popup/Modal");
const useActiveSpectrumPeaksViewState_1 = require("../../hooks/useActiveSpectrumPeaksViewState");
const useCheckExperimentalFeature_1 = __importDefault(require("../../hooks/useCheckExperimentalFeature"));
const useFormatNumberByNucleus_1 = require("../../hooks/useFormatNumberByNucleus");
const useSpectrum_1 = __importDefault(require("../../hooks/useSpectrum"));
const BasicPanelStyle_1 = require("../extra/BasicPanelStyle");
const DefaultPanelHeader_1 = __importStar(require("../header/DefaultPanelHeader"));
const PreferencesHeader_1 = __importDefault(require("../header/PreferencesHeader"));
const PeaksPreferences_1 = __importDefault(require("./PeaksPreferences"));
const PeaksTable_1 = __importDefault(require("./PeaksTable"));
const PeaksToggleActions_1 = require("./PeaksToggleActions");
function PeaksPanelInner({ peaks, info, xDomain, activeTab, peaksViewState, }) {
    const [filterIsActive, setFilterIsActive] = (0, react_2.useState)(false);
    const [isFlipped, setFlipStatus] = (0, react_2.useState)(false);
    const format = (0, useFormatNumberByNucleus_1.useFormatNumberByNucleus)(info.nucleus);
    const dispatch = (0, DispatchContext_1.useDispatch)();
    const modal = (0, Modal_1.useModal)();
    const alert = (0, Alert_1.useAlert)();
    const isExperimental = (0, useCheckExperimentalFeature_1.default)();
    const settingRef = (0, react_2.useRef)();
    const yesHandler = (0, react_2.useCallback)(() => {
        dispatch({ type: 'DELETE_PEAK', payload: {} });
    }, [dispatch]);
    const handleDeleteAll = (0, react_2.useCallback)(() => {
        modal.showConfirmDialog({
            message: 'All records will be deleted, Are You sure?',
            buttons: [{ text: 'Yes', handler: yesHandler }, { text: 'No' }],
        });
    }, [modal, yesHandler]);
    const settingsPanelHandler = (0, react_2.useCallback)(() => {
        setFlipStatus(!isFlipped);
    }, [isFlipped]);
    const saveSettingHandler = (0, react_2.useCallback)(() => {
        settingRef.current.saveSetting();
        setFlipStatus(false);
    }, []);
    const handleOnFilter = (0, react_2.useCallback)(() => {
        setFilterIsActive(!filterIsActive);
    }, [filterIsActive]);
    const filteredPeaks = (0, react_2.useMemo)(() => {
        if (peaks?.values) {
            const [from, to] = xDomain;
            const _peaks = filterIsActive
                ? peaks.values.filter((peak) => (0, isInRange_1.default)(peak.x, { from, to }))
                : peaks.values;
            return _peaks
                .map((peak) => {
                const { x, y, width, ...peakProperties } = peak;
                const value = Number(format(x));
                return {
                    ...peakProperties,
                    x,
                    xHz: info?.originFrequency && value * info.originFrequency,
                    y,
                    width,
                    isConstantlyHighlighted: (0, isInRange_1.default)(value, { from, to }),
                };
            })
                .sort((prev, next) => prev.x - next.x);
        }
        return [];
    }, [filterIsActive, format, info, peaks, xDomain]);
    const optimizePeaksHandler = () => {
        const [from, to] = xDomain;
        const filterPeaks = peaks.values.filter((peak) => (0, isInRange_1.default)(peak.x, { from, to }));
        if (filterPeaks.length <= 4) {
            dispatch({ type: 'OPTIMIZE_PEAKS', payload: { peaks: filterPeaks } });
        }
        else {
            alert.error('optimization can be done on no more than 4 peaks');
        }
    };
    function toggleViewProperty(key) {
        dispatch({ type: 'TOGGLE_PEAKS_VIEW_PROPERTY', payload: { key } });
    }
    function toggleDisplayingMode() {
        dispatch({ type: 'TOGGLE_PEAKS_DISPLAYING_MODE' });
    }
    const counter = peaks?.values?.length || 0;
    const disbale = !peaks?.values || peaks.values.length === 0;
    return ((0, jsx_runtime_1.jsxs)("div", { css: [
            BasicPanelStyle_1.tablePanelStyle,
            isFlipped &&
                (0, react_1.css) `
            .table-container {
              table,
              th {
                position: relative !important;
              }
            }
          `,
        ], children: [!isFlipped && ((0, jsx_runtime_1.jsxs)(DefaultPanelHeader_1.default, { counter: counter, counterLabel: (0, DefaultPanelHeader_1.createFilterLabel)(counter, filterIsActive && filteredPeaks?.length), onDelete: handleDeleteAll, deleteToolTip: "Delete All Peaks", onFilter: handleOnFilter, filterToolTip: filterIsActive ? 'Show all peaks' : 'Hide peaks out of view', showSettingButton: true, onSettingClick: settingsPanelHandler, children: [isExperimental && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ActiveButton_1.default, { style: { marginLeft: '2px', marginRight: '2px' }, popupTitle: peaksViewState.showPeaksShapes
                                    ? 'Hide peaks shapes'
                                    : 'Show peaks shapes', popupPlacement: "right", onClick: () => toggleViewProperty('showPeaksShapes'), disabled: disbale, value: peaksViewState.showPeaksShapes, children: (0, jsx_runtime_1.jsx)(Peaks_1.default, { style: { pointerEvents: 'none', fontSize: '12px' } }) }), (0, jsx_runtime_1.jsx)(ActiveButton_1.default, { style: { marginLeft: '2px', marginRight: '2px' }, popupTitle: peaksViewState.showPeaksSum
                                    ? 'Hide peaks sum'
                                    : 'Show peaks sum', popupPlacement: "right", onClick: () => toggleViewProperty('showPeaksSum'), disabled: disbale, value: peaksViewState.showPeaksSum, children: (0, jsx_runtime_1.jsx)(cheminfo_font_1.SvgNmrFt, { style: { pointerEvents: 'none', fontSize: '12px' } }) }), (0, jsx_runtime_1.jsx)(Button_1.default.BarButton, { onClick: optimizePeaksHandler, toolTip: "Optimize peaks", tooltipOrientation: "horizontal", children: (0, jsx_runtime_1.jsx)(fa_1.FaThinkPeaks, {}) })] })), (0, jsx_runtime_1.jsx)(PeaksToggleActions_1.PeaksToggleActions, { disbale: disbale, showPeaks: peaksViewState.showPeaks, onShowToggle: () => toggleViewProperty('showPeaks'), displayingMode: peaksViewState.displayingMode, onDisplayingModeToggle: toggleDisplayingMode })] })), isFlipped && ((0, jsx_runtime_1.jsx)(PreferencesHeader_1.default, { onSave: saveSettingHandler, onClose: settingsPanelHandler })), (0, jsx_runtime_1.jsx)("div", { className: "inner-container", children: !isFlipped ? ((0, jsx_runtime_1.jsx)(PeaksTable_1.default, { data: filteredPeaks, info: info, activeTab: activeTab })) : ((0, jsx_runtime_1.jsx)(PeaksPreferences_1.default, { ref: settingRef })) })] }));
}
const MemoizedPeaksPanel = (0, react_2.memo)(PeaksPanelInner);
const emptyData = { peaks: null, info: {} };
function PeaksPanel() {
    const { xDomain, view: { spectra: { activeTab }, }, } = (0, ChartContext_1.useChartData)();
    const { peaks, info } = (0, useSpectrum_1.default)(emptyData);
    const preferences = (0, PreferencesContext_1.usePreferences)();
    const peaksViewState = (0, useActiveSpectrumPeaksViewState_1.useActiveSpectrumPeaksViewState)();
    return ((0, jsx_runtime_1.jsx)(MemoizedPeaksPanel, { peaks, info, xDomain, activeTab, preferences, peaksViewState }));
}
exports.default = PeaksPanel;
